import { Injectable } from '@angular/core';

import { HttpClientHelper } from 'src/app/helpers/HttpClientHelper';
import { HttpParameter } from 'src/app/datatypes/misc';

@Injectable({providedIn: 'root'})
export class SkeletonUnsubscribeService {

    constructor(private httpClientHelper: HttpClientHelper) {}

    oneClickUnsubscribe(token: string) {
        return this.httpClientHelper.httpGet(new HttpParameter('JobAlert.OneClickUnsubscribe', [`?token=${token}`]));
    }
}
